module.exports = __webpack_public_path__ + "img/travel-banner_0.40824946.jpg";